import { render, staticRenderFns } from "./posBreakTab.vue?vue&type=template&id=039121fe&"
import script from "./posBreakTab.vue?vue&type=script&lang=js&"
export * from "./posBreakTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports